// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#m2g-view .m2g-customer-balances__balance {\n  text-align: center;\n  font-size: 4em;\n  font-weight: bold;\n}\n#m2g-view .m2g-customer-balances__title {\n  font-size: 1em;\n  text-align: center;\n  font-weight: bold;\n}\n#m2g-view .m2g-customer-balances__title_load_status {\n  font-size: 1em;\n  text-align: center;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
